import React, {Fragment, useEffect, useState} from 'react';
import { t } from 'translates';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import { DateUtils } from 'react-day-picker';
import Daypicker from 'common/components/Form/Daypicker';
import dateFormat from 'dateformat';
import format from 'common/helpers/dateFormat';
import isMobile from 'common/helpers/isMobile';

function Dates(props) {
  const [range, setRange] = useState({from: props.start_date, to: props.end_date});
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    if (!isMobile) {
      setRange({from: props.start_date, to: props.end_date});
    }
  }, [props.start_date, props.end_date]);

  useEffect(() => {
    if (isMobile) {
      setRange({from: props.start_date, to: props.end_date});
    }
  }, [props.filterOpen]);

  useEffect(() => {
    if (isMobile) {
      const formatedStart = range.from ? dateFormat(range.from, 'isoDate') : range.from;
      const formatedEnd =range.to ? dateFormat(range.to, 'isoDate') : range.to;
      props.change(formatedStart,formatedEnd);
    }
  }, [range]);

  const toggle = (e) => {
    if (isMobile) {
      if (dropdownOpen && ( !e.target.classList.contains('sessions-new-filter__date-trigger') )) {
        return;
      }
    } else {
      setRange({from: props.start_date, to: props.end_date});
    }
    setDropdownOpen(prevState => !prevState);
  };

  const isSelectingFirstDay = (from, to, day) => {
    const isBeforeFirstDay = from && DateUtils.isDayBefore(day, from);
    const isRangeSelected = from && to;
    return !from || isBeforeFirstDay || isRangeSelected;
  };

  const handleDayClick = (day) => {
    const rangeData = DateUtils.addDayToRange(day, range);
    setRange(rangeData);

    if (isSelectingFirstDay(range.from, range.to, day)) {
      setRange({from: day, to: undefined});
    } else {
      setRange({from: range.from, to: day});
    }
  };

  const clearDate = () => {
    props.change(null,null);
    toggle();
  };

  const setDate = () => {
    const formatedStart = range.from ? dateFormat(range.from, 'isoDate') : range.from;
    const formatedEnd =range.to ? dateFormat(range.to, 'isoDate') : range.to;
    props.change(formatedStart,formatedEnd);
    toggle();
  };

  const session_days = props.session_days ? props.session_days.map((el) => new Date(el)) : [];

  return (
    <Dropdown className={`sessions-new-filter__date ${isMobile && 'sessions-new-filter__date--mobile'}`} direction="down" isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle
        className='sessions-new-filter__date-trigger'
        tag="button"
        data-toggle="dropdown"
        aria-expanded={dropdownOpen}
      >
        {range.from && range.to ? `${t('From', DT_SESSIONSNEW)} ${range.from.format(props.date_format)} ${t('to', DT_SESSIONSNEW)} ${range.to.format(props.date_format)}`: t('Choose Dates', DT_SESSIONSNEW)}
      </DropdownToggle>
      <DropdownMenu className='sessions-new-filter__date-dropdown'>
        <Daypicker
          className="Selectable"
          fromMonth={new Date(props.min ? props.min : range.from)}
          toMonth={new Date(props.max ? props.max : range.to)}
          month={range.from ? new Date(range.from) : props.min ? new Date(props.min) : undefined}
          numberOfMonths={isMobile ? 1 : 2}
          firstDayOfWeek={+props.first_day}
          disabledDays={{ daysOfWeek: props.days_off.map(Number) }}
          modifiers={
            {
              start: range.from,
              end: range.to,
              start_only: range.to ? undefined : range.from,
              booked: session_days,
            }
        }
          onDayClick={handleDayClick}
          selectedDays={[range.from, { from: range.from, to: range.to }]}
        />
        <div className="sessions-new-filter__footer">
          <div className="sessions-new-filter__note">

            {t('Sessions available', DT_SESSIONSNEW)}
          </div>
          {!isMobile && (
            <div>
              <button className='sessions-new-filter__date-clear'  onClick={() => clearDate()}>{t('Reset', DT_SESSIONSNEW)}</button>
              <button  className='sessions-new-filter__date-apply' onClick={() => setDate()}>{t('Apply', DT_SESSIONSNEW)}</button>
            </div>
          )}
        </div>
      </DropdownMenu>
    </Dropdown>
  );
}

export default  Dates;
